import React, { useContext } from "react";

import uprightarrow from "../images/uprightarrow.png";
import contacthero from "../images/contacthero.jpg";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FAQS from "../components/faq";
import Reviews from "../components/reviews";
import { SectionsContext } from "../store/section-context";
import logo from "../images/logo.png";

function Contact() {
  const { contact } = useContext(SectionsContext);
  const { meta, hero, summary, connect, faq } = contact;
  return (
    <div>
      <Helmet>
        {/* Title and Meta Description */}
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta
          property="og:url"
          content="https://www.brookshealthandcare.com/contact"
        />
        <meta property="og:image" content={logo} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Brooks Health and Care" />
        <meta property="og:locale" content="en_GB" />{" "}
        <meta name="twitter:card" content="summary_large_image" />{" "}
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={logo} />
        <link
          rel="canonical"
          href="https://www.brookshealthandcare.com/"
        />{" "}
        <meta name="author" content="Brooks Health and Care" />
        <meta name="robots" content="index, follow" />{" "}
      </Helmet>
      {/* <div>
        <div className="">
          <img
            src={contacthero}
            className="d-block w-100  aboutheroimg"
            alt="An aged woman experiencing peace of mind."
          />
          <div className="carousel-caption d-block">
            <div className="lhs lhsmobile">
              <div className="lhsheading">
                {" "}
                <span className="thick-dot"></span>{" "}
                <span className="ps-1">
                  {" "}
                  JOIN OUR TEAM AT BROOKS HEALTH AND CARE{" "}
                </span>{" "}
              </div>
              <div className="lhssubtitle pt-3">
                Explore Exciting Career Opportunities with Brooks{" "}
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="aboutheroreplacement p-md-5 p-4"
        style={{
          backgroundImage: `url(${hero.uri || contacthero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          backgroundColor: "rgb(0 0 0 / 70%)",
        }}
      >
        <div className="aboutheroreplacementbox">
          <div className="lhsheading">
            {" "}
            <span className="thick-dot"></span>{" "}
            <span className="ps-1">{hero.headline}</span>{" "}
          </div>
          <div className="lhssubtitle pb-1 pt-3">{hero.subheadline}</div>
        </div>
      </div>
      <div
        className="aboutsegment1 px-5  pt-5 pb-md-3"
        dangerouslySetInnerHTML={{ __html: summary }}
      ></div>
      <div className="horizontal-border-line pt-3"></div>
      <div className="d-lg-flex p-4 p-md-5 contactformflex">
        <div className="slideLeft">
          <div className="contactheading">{connect.title}</div>
          <div className="contactsubheading py-4">{connect.intro}</div>
          <div className="d-flex contacticoncontainer ">
            <div>
              <i className="fa-solid fa-envelope contacticon"></i>
            </div>
            <Link
              className="contactmail pt-1 ps-2"
              to={`mailto:admin@brookshealthandcare.com?subject=Interested%20In%20Services&body=Hello!%20I'm%20interested%20in...`}
            >
              admin@brookshealthandcare.com
            </Link>
          </div>
          <div className="py-4">
            <div className="d-flex contacticoncontainer ">
              <div>
                <i className="fa-solid fa-phone contacticon"></i>
              </div>
              <div className="contactmail pt-1 ps-2">
                {" "}
                <a className="tellink" href="tel:+441234954004">
                  01234954004
                </a>
              </div>
            </div>
          </div>
          <div className="">
            <div className="d-flex contacticoncontainer ">
              <div>
                <i className="fa-solid fa-location-dot contacticon"></i>{" "}
              </div>
              <div className="contactmail pt-1 ps-2">
                Juniper walk, Kempston, Bedford. MK42 7SX
              </div>
            </div>
          </div>
          <div className="contactmail pt-5 pb-3">Follow Us on Social Media</div>
          <div className="contacticons d-flex ">
            <div>
              <a
                href="https://www.facebook.com/profile.php?id=61557096390057"
                className="fa-brands fa-facebook contacticon"
                aria-label="Contact us via Facebook"
              ></a>{" "}
            </div>
            <div>
              <a
                href="https://www.instagram.com/brookshealthandcareltd?igsh=ajV4YjVhZ2Exc2tp&utm_source=qr"
                className="fa-brands fa-instagram contacticon"
                aria-label="Contact us via Instagram"
              ></a>{" "}
            </div>
            <div>
              <a
                href="https://api.whatsapp.com/send?phone=447961929342"
                className="fa-brands fa-whatsapp contacticon"
                aria-label="Contact us via WhatsApp"
              ></a>{" "}
            </div>
          </div>
        </div>
        <div className="pt-4 pt-lg-1 slideRight">
          <form
            action="https://formspree.io/f/xjvnjbev"
            method="POST"
            className="contactform"
          >
            <div className="formgroup">
              <div className="formgroupsection pb-3 pb-md-1">
                <label htmlFor="fname">First Name</label>
                <input
                  type="text"
                  id="fname"
                  name="firstname"
                  placeholder="Enter First Name"
                  className="mobileinput"
                />
              </div>
              <div className="formgroupsection ">
                <label htmlFor="lname">Last Name</label>
                <input
                  type="text"
                  id="lname"
                  name="lastname"
                  placeholder="Enter Last Name"
                  className="mobileinput"
                />
              </div>
            </div>

            <div className="formgroupsection">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="emaill"
                name="email"
                placeholder="Enter Your Email "
                className="maxwidth"
              />
            </div>
            <div className="formgroupsection pt-3">
              <label htmlFor="email">Phone</label>
              <input
                type="phone"
                id="phone"
                name="phone"
                placeholder="Enter Your Phone Number "
                className="maxwidth"
              />
            </div>
            <div className="formgroupsection pt-3">
              <label htmlFor="message">Message</label>
              <textarea
                className="messageform"
                id="message"
                name="message"
                placeholder="Enter your Message here..."
              ></textarea>
            </div>
            <div className="contactformbtn pt-3">
              <button className="testimonialbtn footertestimonialbtn">
                <span className="pe-2">Send Message</span>{" "}
                <img
                  src={uprightarrow}
                  alt="arrow"
                  className="homeSegment6testimoialarrow footerhomeSegment6testimoialarrow"
                />
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* --------------HOME SEGMENT 6-------------- */}
      <Reviews />
      {/* --------------HOME SEGMENT 7-------------- */}
      <FAQS data={faq} />
    </div>
  );
}
export default Contact;
